@if (selectedTabDv === 2 && (werknemerEntity$ | async)) {
  @if (checkEinddatum()) {
    <snelstart-ui-button (click)="addRij()"
                         class="snelstart-ui-button mb-1"
                         icon="plus"
                         id="cancel"
                         type="link">Nieuwe periode toevoegen
    </snelstart-ui-button>
  }

  <form [formGroup]="lijstFg">
    <div formArrayName="contractGegevens">
      @for (item of contractGegevens.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="details-row">
            <div class="d-flex flex-wrap align-items-end gap-2">
              <div class="d-flex gap-2 align-items-end">
                <snelstart-ui-date-form-control
                  [disabledControl]="true"
                  [formControl]="item.controls.periode.controls.begindatum"
                  [label]="i === 0 ? 'Ingangsdatum' : ''"
                  class="custom-input-150"
                  id="begindatum6">
                </snelstart-ui-date-form-control>

                <snelstart-ui-date-form-control
                  [disabledControl]="hasGeldigeEinddatum(i)"
                  [formControl]="item.controls.periode.controls.einddatum"
                  [label]="i === 0 ? 'Einddatum' : ''"
                  class="custom-input-150"
                  id="einddatum6">
                </snelstart-ui-date-form-control>
              </div>

              <snelstart-ui-select-form-control
                                                [disabledControl]="hasGeldigeEinddatum(i)"
                                                [formControl]="item.controls.bepaaldeTijd"
                                                [label]="0 === (i) ? 'Contractduur' : ''"
                                                [options]="optionsJaNeeBepaaldeTijd"
                                                class="custom-input-150"
                                                id="bepaaldeTijd">
              </snelstart-ui-select-form-control>

              <snelstart-ui-select-form-control
                                                [disabledControl]="hasGeldigeEinddatum(i)"
                                                [formControl]="item.controls.schriftelijkeOvereenkomst"
                                                [label]="0 === (i) ? 'Schriftelijk contract' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-150"
                                                id="schriftelijkeOvereenkomst">
              </snelstart-ui-select-form-control>

              <snelstart-ui-select-form-control
                                                [disabledControl]="hasGeldigeEinddatum(i)"
                                                [formControl]="item.controls.oproepovereenkomst"
                                                [label]="0 === (i) ? 'Oproepcontract' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-150"
                                                id="oproepovereenkomst">
              </snelstart-ui-select-form-control>

              @if (isActieveVerwijderbareRegel(i)) {
                <div class="btn-align-up-icon">
                  <snelstart-ui-button
                    (click)="verwijderRijContract(i)"
                    icon="trash"
                    id="delete"
                    size="medium"
                    type="secondary">
                  </snelstart-ui-button>
                </div>
              }
            </div>
            @if (item.controls.periode.hasError('begindatumVoorDatumInDienst') || item.controls.periode.hasError('einddatumVoorBegindatum')) {
              <div class="mb-2" style="margin-top: -8px;">
                @if (item.controls.periode.hasError('begindatumVoorDatumInDienst')) {
                  <div class="text-danger small">Ingangsdatum mag niet vóór datum indienst liggen.</div>
                }
                @if (item.controls.periode.hasError('einddatumVoorBegindatum')) {
                  <div class="text-danger small">Einddatum mag niet vóór ingangsdatum liggen.</div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </form>
}

<!--dialog contract-->
<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="contract" size="xl" title="Bijzonderheden contract">
  <snelstart-ui-dialog-body>
    <form [formGroup]="lijstFg">
      <div formArrayName="contractGegevens">
        @for (item of contractGegevens.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            @if (i === index) {
              <div>

              </div>
            }
          </div>
        }
      </div>
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button (click)="saveForm()" icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
